// @Vendors
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';


// @Components
import StaticImg from '../StaticImg';

const BtnNav = ({ onClick, link = null, className, img, imgactive, text }) => {
	const navArrow = (
		<div className="arrow">
			<StaticImg src='icon/icon_arrow_nav.svg' />
		</div>
	);

	if (link) {
		return (
			<Link to={link} className={className}>
				<div className="icon">
					<StaticImg src={img} className='inactive' />
					<StaticImg src={imgactive} className='active' />
				</div>
				<div className="text">
					{text}
				</div>
			</Link>
		);
	} else {
		return (
			<a onClick={onClick} role="link" className={className}>
				<div className="icon">
					<StaticImg src={img} className='inactive' />
					<StaticImg src={imgactive} className='active' />
				</div>
				<div className="text">
					{text}
				</div>
				{navArrow}
			</a>
		);
	}
};

const SubNavBtn = ({ className, link = '/', text }) => {
	return (
		<li>
			<Link className={className} to={link}>{text}</Link>
		</li>
	)
};

class Nav extends Component {
	state = {
		dropdownOpens: []
	}

	handleDropdawn = id => {
		const { dropdownOpens } = this.state;
		const pos = dropdownOpens.indexOf(id)
		if (pos === -1) {
			dropdownOpens.push(id);
		} else {
			dropdownOpens.splice(pos, 1)
		}

		this.setState({ dropdownOpens });
	}

	isCurrentPath = path => {
		const { location: { pathname } } = this.props;
		let currentPath = false;

		if (Array.isArray(path)) {
			path.forEach(item => {
				if (!currentPath && pathname.indexOf(item) > -1) {
					currentPath = true;
				}
			});
		} else {
			if (path === '/') {
				currentPath = path === pathname;
			} else {
				currentPath = pathname.indexOf(path) > -1;
			}
		}

		return currentPath;
	}

	render() {
		const { navOpen, actionButtonNav } = this.props;
		const { dropdownOpens } = this.state;

		return (
			<div id="nav_bar">
				<nav>
					<ul>
						<li>
							<BtnNav
								className={this.isCurrentPath('/') ? 'active' : ''}
								link="/"
								text="Dashboard"
								img="icon/icon_nav_user.svg"
								imgactive="icon/icon_nav_user_active.svg"
							/>
						</li>

						<li>
							<BtnNav
								className={this.isCurrentPath('/checkinout') ? 'active' : ''}
								link="/checkinout"
								text="Check in/out"
								img="icon/icon_nav_user.svg"
								imgactive="icon/icon_nav_user_active.svg"
							/>
						</li>
					</ul>
				</nav>
				<div id="legal">® Hooli | Todos los derechos reservados</div>
				<button id="btn_colaps" className={navOpen ? '' : 'active'} onClick={actionButtonNav}>
					<StaticImg src='icon/btn_colaps.svg' className='inactive' />
				</button>
			</div>
		);
	}
}

export default withRouter(Nav);



// WEBPACK FOOTER //
// ./src/components/nav/Nav.js